import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EnrichedWatchlistItem } from './enriched-watchlist.models';

import { ENRICHED_WATCHLIST_FEATURE_KEY, EnrichedWatchlistState } from './enriched-watchlist.reducer';

import { WatchlistItem } from '../watchlist/watchlist.models';
import { getAllWatchlistItems } from '../watchlist/watchlist.selectors';

// Lookup the 'EnrichedWatchlist' feature state managed by NgRx
export const getState = createFeatureSelector<EnrichedWatchlistState>(ENRICHED_WATCHLIST_FEATURE_KEY);

export const isLoaded = createSelector(getState, (state: EnrichedWatchlistState) => state.loaded);

export const getItems = createSelector(
  getState,
  getAllWatchlistItems,
  (state: EnrichedWatchlistState, watchlistItems: WatchlistItem[]) =>
    watchlistItems
      .map(
        (watchlistItem): EnrichedWatchlistItem => ({
          ...(state.itemsOnPage.find(
            (item) => item.entity_id === watchlistItem.entity_id && item.entity_type === watchlistItem.entity_type
          ) ?? watchlistItem),
          ...watchlistItem,
        })
      )
      .filter((item) => !item.hasError)
);

export const getCurrentPage = createSelector(getState, (state: EnrichedWatchlistState) => state.currentPage);

export const getItemCategory = createSelector(getState, (state: EnrichedWatchlistState) => state.itemCategory);

export const getCachedItems = createSelector(getState, (state: EnrichedWatchlistState) => state.cachedItems);

export const getPageCount = createSelector(getState, (state: EnrichedWatchlistState) => state.pageCount);

export const getItemCount = createSelector(getState, (state: EnrichedWatchlistState) => state.itemCount);
